export const POUND_SYMBOL = '£'

export const CONTAINER_MAX_WIDTH = '800px'

export const DATE_FORMAT = 'dd/MM/yyyy'
